<template>
  <div class="wrapper wrapper_wide section_content">
    <!-- <div class="frame_wide">
      <Greeting v-bind="info"/>
    </div> -->
    <div class="frame_center">
      <newInfo></newInfo>
      <Feature v-bind="home.concept"/>
      <!-- <Feature v-bind="home.contact" :imgName="'contact'"/> -->
      <!-- <ReservedBtns /> -->
      <!-- <Timetable /> -->
      <Feature v-bind="home.about" :featureName="'about'" :bg="true" :imgName="'about'" :titlePos="false"/>
      <FloorDetails></FloorDetails>
      <AddressMap />
      <!-- <Facility v-for="(point, idx) in home.points" v-bind="point" :idx="idx"/> -->
      <Feature v-bind="home.gallary" :featureName="'gallary'" :bg="true" :imgName="'gallary'" />
      <!-- <Fusion /> -->
      <!-- <Consultation /> -->
    </div>
  </div>
</template>

<script>
// molcules
import ReservedBtns from '../molcules/reserved_btns.vue'
import newInfo from '../molcules/newInfo.vue'

// organisms
import AddressMap from '../organisms/addressMap.vue'
import Facility from '../organisms/facility.vue'
import Feature from '../organisms/feature.vue'
import Fusion from '../organisms/fusion.vue'
import Greeting from '../organisms/greeting.vue'
import Timetable from '../organisms/timetable.vue'
import Consultation from '../organisms/consultation.vue'
import FloorDetails from '../organisms/floorDetails.vue'

import { mapState } from 'vuex'

export default {
  name: 'HomeContents',
  components: {
    newInfo,
    ReservedBtns,
    AddressMap,
    Facility,
    Feature,
    Fusion,
    Greeting,
    Timetable,
    Consultation,
    FloorDetails
  },
  props: {
    msg: String
  },
  data () {
    return {
      home: siteData.home,
      info: siteData.info,
      detail: siteData.detail
    }
  },
  computed: {
    ...mapState([
      'siteData'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
